import useSWR from 'swr';

import { fetchSegment } from 'src/store/api';

function fetcher(segmentIds, options) {
  if (!segmentIds.length) {
    return undefined;
  }
  return Promise.all(segmentIds.map((id) => fetchSegment(id, options)));
}

export default function usePxScores({ segmentIds, options = {}, config = { shouldFetch: true } }) {
  const { shouldFetch } = config;

  const base = '/core/v1/segments/:id';
  const urls = [base, ...segmentIds.sort().map((segmentId) => base.replace(':id', segmentId))];

  return useSWR(
    shouldFetch ? { key: urls, segmentIds, options } : null,
    ({ segmentIds: s, options: o }) => fetcher(s, o),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    }
  );
}
